import { IconLayersIntersect } from '@tabler/icons';

const icons = { IconLayersIntersect };

const fedi = {
    id: 'litnetFedi',
    type: 'group',
    children: [
        {
            id: 'fedi',
            type: 'item',
            title: 'LITNET Fedi paslauga',
            icon: icons.IconLayersIntersect,
            url: '/fedi'
        }
    ]
};

export default fedi;